'use client';

import Section from '@app/ui/Section/Section';
import { INewsApiModel } from '@app/models/features/news';
import styles from './NewsPostRecommendationsSection.module.scss';
import NewsCard from '@app/features/news/NewsCard/NewsCard';

interface IProps {
    recommendations: INewsApiModel[];
}

// TODO: Complete logic with pagination

const NewsPostRecommendationsSection: React.FC<IProps> = props => {

    const { recommendations } = props;

    // const [currentPage, setCurrentPage] = useState(1);
    //
    // const didPageIncreased = useCallback(() => setCurrentPage(currentPage + 1), [currentPage]);
    //
    // const didPageDecreased = useCallback(() => setCurrentPage(currentPage - 1), [currentPage]);

    return (
        <Section
            animation="none"
            stretch="top"
            title="Рекомендуем"
            tag="div"
            // action={(
            //     <NewsPostPageSwitcher
            //         postsCount={props.recommendations.length}
            //         currentPage={currentPage}
            //         onPageIncrease={didPageIncreased}
            //         onPageDecrease={didPageDecreased}
            //     />
            // )}
        >
            <div className={styles['recommendations']}>
                {recommendations.map(recommendation => (
                    <NewsCard
                        key={recommendation.post_id}
                        postSlug={recommendation.id}
                        title={recommendation.title}
                        description={recommendation.description}
                        url={recommendation.url}
                        image={recommendation.preview_url}
                        tags={recommendation.tags}
                        date={recommendation.date}
                    />
                ))}
            </div>
        </Section>
    );
};

export default NewsPostRecommendationsSection;